// Modal Popup of the Dashboard Bubble Boxes

import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { useEffect } from "react";
import { handleAPI } from "../../../API/handleAPI";
// import TableModal from "../TableModal";
// import "../../assets/css/DashboardTable.css";
import { connect } from "react-redux";
import { ReactComponent as OpenTable } from "../../../assets/svg/OpenTable copy.svg";
import { ReactComponent as CloseSVG } from "../../../assets/svg/Close.svg";
import { TextField } from "@mui/material";
import Cat23TableModal from "../../InvestorCat2And3/Cat23TableModal";
import InputLabel from "@mui/material/InputLabel";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InvestmentsExtensionModal from "./InvestmentsExtensionModal";
import { ReactComponent as LoadingBlack } from "../../../assets/svg/LoadingBlack.svg";
import { useNavigate } from "react-router-dom";
import ModalLoader from "../../../views/modalLoader";
import Swal from "sweetalert2";
import { popupError } from "../../../utils/errorHandler";
import { AMC_DETAILS } from "../../../variable";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  height: "510px",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "background.paper",
  border: "2px solid black",
  boxShadow: 24,
  borderRadius: 3,
  p: 1,
  padding: "2px 5px",
};

function InvestmentsExtension(props) {
  const [searchString, setSearchString] = useState("");
  const [rows, setRows] = useState([]); // rows data sent to Cat23TableModal for the table i.e data that will be shown in the table
  const [tableDataCat2, setTableDataCat2] = useState([]); // rows data for cat 2
  const [tableDataCat3, setTableDataCat3] = useState([]); // rows data for cat 3
  const [open, setOpen] = useState(false); // to open the modal
  const [loader, setLoader] = useState(false); // loader to wait for api call response
  const [downloadLink, setDownloadLink] = useState({}); // set download link for xlsx and pdf
  const [categoryNumber, setCategoryNumber] = useState(0); // category selected in the dropdown
  const [tableDataCategoryWise, setTableDataCategoryWise] = useState([]);
  const [category2DownloadLink, setCategory2DownloadLink] = useState({});
  const [category3DownloadLink, setCategory3DownloadLink] = useState({});
  const navigate = useNavigate();

  //API Call
  const handleOpen = async () => {
    setOpen(true);
    //console.log("Props.name ----->", props.name);
    //console.log("Props.pan ----->", props.userDetails.pan);

    await handleAPI(
      "/distributor/getDashboardInvestmentDetails",
      {
        pan: props.userDetails.pan,

        fileName: "InvestmentCategory",
        navDate: props.navDate,
      },
      props.token
    )
      .then((response) => {
        // console.log("Data1234--", response.data);
        setTableDataCat2(response.data.investmentCategory2Data);
        setTableDataCat3(response.data.investmentCategory3Data);
        setCategory2DownloadLink({
          xlsxLink: response.data.s3XlsxSignedUrlCategory2,
          pdfLink: response.data.s3PdfSignedUrlCategory2,
        });
        setCategory3DownloadLink({
          xlsxLink: response.data.s3XlsxSignedUrlCategory3,
          pdfLink: response.data.s3PdfSignedUrlCategory3,
        });

        // false for cat 2 ... true for cat 3
        if (props.flag === false) {
          setTableDataCategoryWise(response.data.investmentCategory2Data);
          setRows(response.data.investmentCategory2Data);
          setDownloadLink({
            xlsxLink: response.data.s3XlsxSignedUrlCategory2,
            pdfLink: response.data.s3PdfSignedUrlCategory2,
          });
          setCategoryNumber(2);
        } else {
          setTableDataCategoryWise(response.data.investmentCategory3Data);
          setRows(response.data.investmentCategory3Data);
          setDownloadLink({
            xlsxLink: response.data.s3XlsxSignedUrlCategory3,
            pdfLink: response.data.s3PdfSignedUrlCategory3,
          });
          setCategoryNumber(3);
        }
        setLoader(true);
      })
      .catch((error) => {
        console.log(`Error Message:  ${error.errorMessage}`);
        console.log("Redirecting to error");

        setLoader(true);
      });
  };
  //console.log("XLSX", downloadLink.xlsxLink);
  const handleClose = () => {
    setSearchString("");
    setOpen(false);
    setLoader(false);
  };

  //   Search Functionality
  const handleChange = (event) => {
    setSearchString(event.target.value);
    //console.log("value is:", event.target.value);
    let filteredRows = tableDataCategoryWise.filter((row) => {
      let temp = JSON.stringify(Object.values(row));
      temp = temp.toLowerCase();
      return temp.includes(event.target.value.toLowerCase());
    });

    setRows(filteredRows);
  };

  function downloadXlsxData() {
    window.open(downloadLink.xlsxLink, "_self");
  }

  function downloadPdfData() {
    window.open(downloadLink.pdfLink, "_self");
  }

  // when the category drop down changes
  const handleCategoryNumberChangeAndRow = (event) => {
    // the category number is getting changed ., i.e , in the dropdown
    setCategoryNumber(event.target.value);

    // if chnged to cat2
    if (event.target.value === 2) {
      setTableDataCategoryWise(tableDataCat2);
      setDownloadLink(category2DownloadLink);
    }
    // if changed to cat3
    else if (event.target.value === 3) {
      setTableDataCategoryWise(tableDataCat3);
      setDownloadLink(category3DownloadLink);
    }
    setSearchString("");
  };

  // when tableDataCategoryWise changes , the rows data is the entire Category Data ... schemes also full Cat Data as all schemes by default
  useEffect(() => {
    setRows(tableDataCategoryWise);
  }, [tableDataCategoryWise]);

  //   //console.log("Before Modal Open \nProps.flag= ", props.flag);

  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <>
        <Grid item>
          <Button onClick={handleOpen}>
            <OpenTable />
          </Button>
        </Grid>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ backdropFilter: "blur(10px)" }}
        >
          <Box className="tableBox" sx={style}>
            {loader ? (
              <>
                <Grid item className="header">
                  <Grid item xs={6} className="title">
                    {props.detailHeader}
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    onClick={handleClose}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "right",
                    }}
                  >
                    <CloseSVG />
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    // border: "solid 2px blue",
                    display: "flex",
                    flexDirection: "row",
                    height: "5rem",
                  }}
                >
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3} style={{ fontFamily: "Lato" }}>
                    {AMC_DETAILS.FUND_CATEGORY?.length > 1 && (
                      <FormControl
                        variant="standard"
                        sx={{
                          m: 1,
                          width: "90%",
                          marginRight: "3rem",
                          paddingBottom: "2rem",
                        }}
                      >
                        <InputLabel id="demo-simple-select-standard-label">
                          Category
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={categoryNumber}
                          onChange={handleCategoryNumberChangeAndRow}
                          label="Age"
                        >
                          <MenuItem value={2}>Category II</MenuItem>
                          <MenuItem value={3}>Category III</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      marginRight: "2rem",
                      marginTop: "1rem",
                      marginBottom: "-0.5rem",
                      height: "35px",
                    }}
                  >
                    <div
                      style={{
                        border: "solid 1px black",
                        borderRadius: "30px",
                      }}
                    >
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Search"
                        type="search"
                        onChange={handleChange}
                        value={searchString}
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          ".MuiInputBase-input": {
                            borderBottom: "none !important",
                            padding: "5px 0 0 10px !important",
                            /*margin: -12px ;  */
                          },
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  {/* {//console.log("rows123", rows)} */}
                  <InvestmentsExtensionModal
                    name={props.name}
                    headCells={props.headCells}
                    data={rows}
                  />
                </Grid>

                <div className="downloadBtn">
                  <button
                    style={{ backgroundColor: "#333333" }}
                    onClick={downloadXlsxData}
                    className={
                      downloadLink?.xlsxLink != null
                        ? "btncss"
                        : "btncss-disable"
                    }
                    disabled={downloadLink.xlsxLink === null ? true : false}
                  >
                    Download as Excel
                  </button>
                  <button
                    style={{ backgroundColor: "#333333" }}
                    onClick={downloadPdfData}
                    className={
                      downloadLink?.xlsxLink != null
                        ? "btncss"
                        : "btncss-disable"
                    }
                    disabled={downloadLink.pdfLink === null ? true : false}
                  >
                    Download as PDF
                  </button>
                </div>
              </>
            ) : (
              <Grid
                item
                style={{
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* <LoadingBlack /> */}
                <ModalLoader />
              </Grid>
            )}
          </Box>
        </Modal>
      </>
    </Grid>
  );
}

const mapStatetoProps = (state) => {
  return {
    userDetails: state.mainReducer.userDetails,
    token: state.mainReducer.token,
    navDate: state.mainReducer.navDate,
  };
};

const mapDispatchtoProps = (dispatch) => {
  return {
    setUserDetails: (val) => {
      dispatch({ type: "CHANGE-USER", userDetails: val });
    },
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchtoProps
)(InvestmentsExtension);
